import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AnimalSymbol from "@/components/AnimalSymbol";
import { API_BASE } from "@/lib/config";
import { formatApiError } from "@/contexts/AuthContext";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await axios.post(`${API_BASE}/auth/forgot-password`, { email });
      setSent(true);
    } catch (e2) {
      setErr(formatApiError(e2));
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--app-bg)] p-6">
      <div className="w-full max-w-sm bg-white border border-[var(--app-border)] rounded-lg p-8 shadow-sm">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-md bg-[var(--app-bg)] border border-[var(--app-border)] flex items-center justify-center">
            <AnimalSymbol parts={{ ears: "correct", head: "correct", neck: "correct", front: "correct", back: "correct", rear: "correct", tail: "correct" }} size={32} />
          </div>
          <div className="leading-tight">
            <div className="font-display font-extrabold text-lg tracking-tight">Vitality Pedigree</div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--app-text-soft)]">Reset password</div>
          </div>
        </div>

        {sent ? (
          <div className="space-y-3" data-testid="forgot-sent">
            <p className="text-sm leading-relaxed">
              If <span className="font-mono-tech">{email}</span> is registered, you'll receive a reset link shortly. Check your inbox (and spam folder).
            </p>
            <p className="text-xs text-[var(--app-text-soft)]">The link is valid for 60 minutes.</p>
            <Link to="/login" className="block">
              <Button variant="outline" className="w-full" data-testid="forgot-back-to-login">Back to sign in</Button>
            </Link>
          </div>
        ) : (
          <>
            <p className="text-xs text-[var(--app-text-soft)] mb-5">
              Enter the email you signed up with and we'll send you a reset link.
            </p>
            <form onSubmit={submit} className="space-y-3" data-testid="forgot-form">
              <div>
                <Label className="text-xs uppercase tracking-wider text-[var(--app-text-soft)]" htmlFor="email">Email</Label>
                <Input id="email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
              </div>
              {err && <div className="text-sm text-red-600" data-testid="forgot-error">{err}</div>}
              <Button type="submit" disabled={busy} className="w-full bg-blue-600 hover:bg-blue-700" data-testid="forgot-submit">
                {busy ? "Sending…" : "Send reset link"}
              </Button>
            </form>
            <div className="mt-5 text-center text-sm text-[var(--app-text-soft)]">
              Remembered it?{" "}
              <Link to="/login" className="text-blue-600 hover:underline" data-testid="forgot-link-login">Sign in</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
